import { CurrencyType, ItemizedCostFragment } from 'src/graphql'
import { formatCost } from 'src/helpers'

const getCondensedTotal = (cost: ItemizedCostFragment): string => {
  const freeItem = cost.total.find(item => item.currency === CurrencyType.FREE)
  if (freeItem) {
    return 'FREE'
  }
  const pointsItem = cost.total.find(
    item => item.currency === CurrencyType.POINT,
  )
  const dollarAmount = formatCost(
    cost.total
      .filter(
        item =>
          item.currency === CurrencyType.USD ||
          item.currency === CurrencyType.EXPENSE,
      )
      .reduce((acc, currentItem) => acc + currentItem.amount, 0),
  )
  return pointsItem ? `${pointsItem.asString} + ${dollarAmount}` : dollarAmount
}

export default getCondensedTotal
